<template>
  <div>
    <component
      :is="isLink ? 'a' : 'span'"
      v-bind="
        isLink
          ? { href: linkForLot, target: '_blank', rel: 'noopener noreferrer' }
          : {}
      "
      class="proposal-number-link"
    >
      {{ displayValue }}
    </component>
  </div>
</template>

<script>
export default {
  name: "ProposalNumberCell",
  props: ["value", "row", "column"],

  computed: {
    isLink() {
      return this.$store.getters["auth/authorities"]?.includes(
        "ROLE_SUBSCRIBED_USER",
      );
    },

    displayValue() {
      return this.value?.proposalNumber || "-";
    },

    linkForLot() {
      const value = this.value;

      if (!value || typeof value !== "object") {
        return "#";
      }

      const { url, proposalSource, proposalNumber } = value;

      if (!url) {
        return "#";
      }

      try {
        const newUrl = new URL(url);

        const sources = [
          "https://sapsrm.beloil.by",
          "https://zakupki.minsktrans.by",
          "https://belaruskali.by",
          "https://belarus-tr.gazprom.ru",
        ];

        if (sources.includes(proposalSource) && proposalNumber) {
          newUrl.searchParams.append("number", proposalNumber);
        }

        return newUrl.href;
      } catch (e) {
        console.warn("Invalid lot URL:", value, e);
        return "#";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.proposal-number-link {
  color: rgb(55, 71, 79);
  &:visited {
    color: rgb(159, 173, 181);
  }
}
</style>
